<template>
  <div class="v-container">
    <div class="v-page-header">区域列表</div>
    <div class="v-header">
      <el-button @click="showAddEdit()" size="small" type="primary">新增区域</el-button>
      <div>
        <el-select v-model="region_city_id" size="mini" class="v-mr-5">
          <el-option v-for="item in cityList" :value="item.id" :key="item.id" :label="item.region_short_name"></el-option>
        </el-select>
        <el-button class="v-ml-5" type="primary" size="mini" @click="getList(1)">搜索</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="v-content" v-loading="loading">
      <el-table border size="small" :data="lists" height="100%">
        <el-table-column label="排序值" width="100" prop="sort"></el-table-column>
        <el-table-column label="区域名称" prop="name"></el-table-column>
        <el-table-column label="所属城市" prop="city_name" width="200"></el-table-column>
        <el-table-column label="展示风格" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.spread == 1">三图</span>
            <span v-if="scope.row.spread == 2">四图</span>
            <span v-if="scope.row.spread == 3">四+一图</span>
            <span v-if="scope.row.spread == 4">五图</span>
            <span v-if="scope.row.spread == 5">六图</span>
            <span v-if="scope.row.spread == 6">一图</span>
            <span v-if="scope.row.spread == 7">二图</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="showAddEdit(scope.row)" size="min" class="v-ml-5" type="warning">编辑</el-button>
            <el-popconfirm title="确认删除？" @onConfirm="doDelete(scope.row)">
              <el-button slot="reference" size="min" class="v-ml-5" type="danger" :loading="scope.row.deleteLoading">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="v-footer">
      <el-pagination
        layout="total,sizes,prev, pager, next"
        @size-change="
          (page_size) => {
            getList(page, page_size);
          }
        "
        @current-change="
          (page) => {
            getList(page);
          }
        "
        :current-page.sync="page"
        :total="total"
      ></el-pagination>
    </div>
    <add-edit
      v-if="isShowAddEdit"
      :show.sync="isShowAddEdit"
      :row="row"
      @success="
        (page) => {
          getList(page);
        }
      "
    ></add-edit>
  </div>
</template>

<script>
import addEdit from './components/add-edit';

export default {
  components: { addEdit },

  data() {
    return {
      loading: false,
      page: 1,
      page_size: 10,
      lists: [],
      total: 0,
      row: null,
      isShowAddEdit: false,
      isShowConfig: false,
      city_id: this.$store.getters.userInfo.city_id,
      cityList: [],
      region_city_id: '',
    };
  },
  mounted() {
    this.getList();
    this.getCityList();
  },

  methods: {
    async getList(page, page_size) {
      this.loading = true;
      this.page = page ? page : this.page;
      this.page_size = page_size ? page_size : this.page_size;
      try {
        let res = await this.api.region.areaList({
          page: this.page,
          page_size: this.page_size,
          region_city_id: this.region_city_id,
        });
        this.lists = res.data.data;
        this.total = res.data.total;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    reset() {
      this.region_city_id = '';
      this.getList(1);
    },

    async getCityList() {
      this.loading = true;
      try {
        let res = await this.api.region.getUseCity();
        this.cityList = res.data;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    showAddEdit(row) {
      this.row = row;
      this.isShowAddEdit = true;
    },

    showConfig(row) {
      this.row = row;
      this.isShowConfig = true;
    },

    //删除
    async doDelete(row) {
      this.$set(row, 'deleteLoading', true);
      try {
        await this.api.region.deleteArea({ id: row.id });
        this.$message.success('删除成功');
        this.getList();
      } catch (e) {
        console.error(e);
      }
      this.$set(row, 'deleteLoading', false);
    },
  },
};
</script>

<style scoped>
.v-header {
  display: flex;
  justify-content: space-between;
}
</style>
